import { render, staticRenderFns } from "./VideoContent.vue?vue&type=template&id=56870b7e&scoped=true"
import script from "./VideoContent.vue?vue&type=script&lang=js"
export * from "./VideoContent.vue?vue&type=script&lang=js"
import style0 from "./VideoContent.vue?vue&type=style&index=0&id=56870b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56870b7e",
  null
  
)

export default component.exports